import { LocationNumbersService } from "../../../services";

const putLocationData = async function ({ commit, dispatch, state }, config) {
    const { locationId, payload } = config
    try {
        const data = await LocationNumbersService.putLocationData(locationId, payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export default putLocationData;
